import { Form } from 'antd';
import styled from 'styled-components';

export const SolidFormItem = styled(Form.Item)<{
  margin?: string;
  hidden?: boolean;
}>`
  font-weight: 400;
  margin: ${props => props.margin || '0 0 24px 0'} !important;
  ${props => props.hidden && 'display: none;'}
  div[class*='-form-item-label'] {
    line-height: 1.3;
    padding: 0 0 4px;
    label {
      font-weight: 600;
      height: auto !important;
      color: var(--v3-text-color);
    }
  }
  div[class*='-form-item-extra'] {
    line-height: 1;
    font-size: 12px;
    min-height: 1px;
    padding-top: 6px;
    color: var(--v3-text-color);
  }
  div[class*='-form-item-explain'] {
    text-align: right;
    top: 126%;
  }

  div[class*='-form-item-explain-connected'] {
    padding: 0;
    min-height: 0;
    width: 100%;
  }

  div[class*='-form-item-explain-error'] {
    min-width: 100px;
    min-height: 0;
  }

  span[class*='-input-prefix'],
  input {
    font-size: 14px;
    line-height: 25px;
  }

  div.inputText__verify-cpf {
    display: flex;
    align-items: center;
  }
`;
